/** @format */

import { fetch } from '../../utils/fetch';
import { functionId } from '../../utils/functionIdConfig';
import { IGetFollowParams, IGetCartParams } from './domain';
const Service = {
  getCart: (params_json: IGetCartParams): Promise<any> => {
    const defaultParams = {
      action: '5',
      page: 1,
      queryType: 1,
      compareCid: params_json.compareCid,
    };
    const params = Object.assign({}, defaultParams, params_json);
    return fetch(functionId, JSON.stringify(params));
  },
  getFollow: (params_json: IGetFollowParams): Promise<any> => {
    const defaultParams = {
      action: '5',
      page: 1,
      queryType: 2,
      pageSize: 30,
      //三级类目id
      compareCid: params_json.compareCid,
    };
    const params = Object.assign({}, defaultParams, params_json);
    return fetch(functionId, JSON.stringify(params));
  },
  getRecord: (params_json: IGetFollowParams): Promise<any> => {
    const defaultParams = {
      action: '5',
      page: 1,
      queryType: 3,
      //todo 修改为30
      pageSize: 8,
      //三级类目id
      compareCid: params_json.compareCid,
    };
    const params = Object.assign({}, defaultParams, params_json);
    return fetch(functionId, JSON.stringify(params));
  },
  addGoods: (params_json: { compareSku: string; compareCid: string }): Promise<any> => {
    const defaultParams = {
      action: '1',
      //要添加的sku
      compareSku: params_json.compareSku,
      compareCid: params_json.compareCid,
    };
    return fetch(functionId, JSON.stringify(defaultParams));
  },
};
export default Service;
